export const START_ZOOM = 1;
export const MAX_ZOOM = 8;
export const ZOOM = 2;
